import { FlexProps } from '.';
import * as S from './Styles';

const FlexCol = (props: FlexProps) => {
  return <S.FlexCol {...props} />;
};

export default FlexCol;
